import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { posthog } from '../../lib/posthog'

const COPY: Record<string, { badge: string; body: string }> = {
  control: {
    badge: 'FEMM',
    body:  'is evidence-based healthcare that teaches you to read your body\'s signals, understand your hormones, and take real ownership of your reproductive health.',
  },
  test: {
    badge: 'FEMM',
    body:  'is evidence-based hormonal healthcare that maps the patterns behind PCOS, subfertility, irregular cycles, thyroid dysfunction and hormonal imbalances so you can move from managing symptoms to understanding their root cause.',
  },
}

export function WhatIsFemm() {
  const [open, setOpen]       = useState(false)
  const [variant, setVariant] = useState<string | null>(null)

  useEffect(() => {
    // getFeatureFlag may return undefined until flags load; re-check once loaded
    const v = posthog.getFeatureFlag('femm-what-is-copy')
    if (v && typeof v === 'string') {
      setVariant(v)
      return
    }
    posthog.onFeatureFlags(() => {
      const loaded = posthog.getFeatureFlag('femm-what-is-copy')
      setVariant(typeof loaded === 'string' ? loaded : 'control')
    })
  }, [])

  const copy = COPY[variant ?? 'control']

  const handleToggle = () => {
    if (!open) {
      posthog.capture('femm_explainer_expanded', { variant: variant ?? 'control' })
    }
    setOpen(v => !v)
  }

  return (
    <div style={{ marginTop: '0.5rem' }}>
      {/* Trigger */}
      <button
        onClick={handleToggle}
        style={{
          display:        'inline-flex',
          alignItems:     'center',
          gap:            '0.35rem',
          background:     'none',
          border:         'none',
          padding:        0,
          cursor:         'pointer',
          fontFamily:     'var(--font-sans)',
          fontSize:       '0.82rem',
          fontWeight:     600,
          color:          'var(--color-deep-teal)',
          letterSpacing:  '0.01em',
        }}
        aria-expanded={open}
      >
        <motion.span
          animate={{ rotate: open ? 90 : 0 }}
          transition={{ duration: 0.2 }}
          style={{ display: 'inline-flex', lineHeight: 1 }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5"
            strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </motion.span>
        What is FEMM?
      </button>

      {/* Expandable body */}
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="femm-explainer"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
            style={{ overflow: 'hidden' }}
          >
            <p style={{
              marginTop:   '0.7rem',
              fontSize:    '0.88rem',
              lineHeight:  1.65,
              color:       '#334155',
              fontFamily:  'var(--font-sans)',
            }}>
              <span style={{
                display:         'inline-block',
                padding:         '0.2rem 0.55rem',
                background:      'var(--color-deep-teal)',
                color:           'white',
                borderRadius:    'var(--radius-full)',
                fontSize:        '0.72rem',
                fontWeight:      700,
                letterSpacing:   '0.08em',
                textTransform:   'uppercase',
                marginRight:     '0.45rem',
                verticalAlign:   'baseline',
                lineHeight:      1.5,
              }}>
                {copy.badge}
              </span>
              {copy.body}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
